import { render, staticRenderFns } from "./grade_range.vue?vue&type=template&id=0e82004d&scoped=true&"
import script from "./grade_range.vue?vue&type=script&lang=js&"
export * from "./grade_range.vue?vue&type=script&lang=js&"
import style0 from "./grade_range.vue?vue&type=style&index=0&id=0e82004d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82004d",
  null
  
)

export default component.exports